export const handleStatusUpdate = (
  closeModalDialog,
  showSnackNotificationAction,
  snackMessage
) => {
  closeModalDialog();
  showSnackNotificationAction(snackMessage);
};
